<template>
  <div>
    <div class="title">开发票注意事项？</div>
    <div class="content-info">
      <p class="txt1">
        ①单张发票不超过10万；
        <br />②无开票周期和时间限制；
        <br />③蔬菜、鸡鸭鹅蛋、鸡鸭鹅肉、牛羊猪肉不能开增值税专用发票，其它品类可开增值税专用发票；
        <br />④开增值税发票：如要求开专票，需要对方提供一般纳税人证件。纳税人证件包括：《税务登记证》副本（若无标示“一般纳税人”字样，需要另行提供《一般纳税人资格登记表》）、《开户许可证》、《营业执照》副本等证件的复印件。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
